export default __webpack_public_path__ + "static/illustration-australia.url-b0cf65abdf06d761be0fced0bb307a39.svg";